(function () {
    const videoPlayToggles = document.querySelectorAll('.play-pause-btn');
    const videoMuteToggles = document.querySelectorAll('.mute-btn');
    let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (videoMuteToggles) {
        videoMuteToggles.forEach(videoToggle => {
            const video = videoToggle.parentElement.querySelector('video');           
            if (!!video) {
                videoToggle.addEventListener('click', function(e){
                    e.preventDefault();
                    const targetToggle = e.currentTarget;
                    const videoEl = targetToggle.parentElement.querySelector('video');
                    const muted = !videoEl.muted;
                    videoEl.muted = muted;
                    targetToggle.setAttribute("aria-label", muted ? "unmute video" : "mute video");
                    if (muted) {
                        videoEl.setAttribute("muted", "muted");
                        targetToggle.classList.remove('active');
                    }
                    else {
                        videoEl.removeAttribute("muted");
                        targetToggle.classList.add('active');
                    }
                });
            }
        });
    }
    if (videoPlayToggles) {
        videoPlayToggles.forEach(videoToggle => {
            const video = videoToggle.parentElement.querySelector('video');           
            if (!!video) {
                videoToggle.addEventListener('click', function(e){
                    e.preventDefault();
                    const targetToggle = e.currentTarget;
                    const videoEl = targetToggle.parentElement.querySelector('video');
                    const videoPlay = videoEl.paused || videoEl.ended;
                    videoEl.controls = 0;
                    if (videoPlay) {
                        videoEl.play();
                        videoEl.classList.add('keep-playing');
                        videoEl.parentElement.classList.add('playing');
                        targetToggle.setAttribute("aria-label", "pause video");
                        targetToggle.classList.add('active');
                    }
                    else {
                        videoEl.pause();
                        videoEl.classList.remove('keep-playing');
                        videoEl.parentElement.classList.remove('playing');
                        targetToggle.setAttribute("aria-label", "play video");
                        targetToggle.classList.remove('active');
                    }
                });
                videoToggle.parentElement.querySelector('video').addEventListener('click', function(e){
                    videoToggle.click();
                });
                video.classList.add('keep-playing');
                if (isMobileDevice) {
                    video.pause();
                    video.classList.remove('keep-playing');
                    video.parentElement.classList.remove('playing');
                    videoToggle.setAttribute("aria-label", "play video");
                    videoToggle.classList.remove('active');
                }
            }
        });
    }
    document.querySelectorAll('video').forEach(vidEl => {
        vidEl.addEventListener('click', videoEl => {
            const isPlay = (videoEl.paused && videoEl.classList.contains('keep-playing'));
            const isPause = !videoEl.paused;
            if (isPause) {
                videoEl.pause();
                videoEl.parentElement.classList.remove('playing');
                let toggle = videoEl.parentElement.querySelector('.utility-btn.play-pause-btn');
                toggle.setAttribute("aria-label", "play video");
                toggle.classList.remove('active');
            }
            else if (isPlay) {
                videoEl.play();
                videoEl.parentElement.classList.add('playing');
                let toggle = videoEl.parentElement.querySelector('.utility-btn.play-pause-btn');
                toggle.setAttribute("aria-label", "pause video");
                toggle.classList.add('active');
            }
        });
    });
})();